import styled from '@emotion/styled'
import { Combobox as HeadlessCombobox } from '@headlessui/react'
import { Key } from 'react'

import {
  DropdownItemStylesProps,
  dropdownItemStyles,
} from '../../constants/styles'
import { SelectedIcon } from '../Dropdown/SelectedIcon'

const Option = styled<any>(HeadlessCombobox.Option)({
  margin: 0,
  outline: 'none',
}) as typeof HeadlessCombobox.Option

const OptionContent = styled.div<DropdownItemStylesProps>((props) => ({
  ...dropdownItemStyles(props),
  alignItems: 'center',
  display: 'flex',
}))

export type ComboboxOption<T> = {
  key: Key
  label: string
  value: T
}

export type ComboboxOptionProps<T> = {
  label: string
  placeholder?: boolean
  small?: boolean
  value: T
}

export const ComboboxOption = <T,>(props: ComboboxOptionProps<T>) => {
  return (
    <Option value={props.value}>
      {({ active, selected }) => (
        <OptionContent
          active={active && !props.placeholder}
          isPlaceholder={props.placeholder}
          small={props.small}
        >
          {props.label}
          <SelectedIcon selected={selected && !props.placeholder} />
        </OptionContent>
      )}
    </Option>
  )
}
